import rancher from "public/application-services/icons/rancher.png";
import { ContentCard } from "@/components/contentCard";

export const HOSTED_RANCHER_FEATURES = {
  title: "Features of Hosted Rancher",
  list: [
    {
      image: rancher,
      title: "Centralized Kubernetes Management",
      content: (
        <ContentCard
          points={[
            "Multi-cluster support to manage Kubernetes clusters across on-premises, cloud, and hybrid environments.",
            "Unified authentication & RBAC for consistent security policies across all clusters.",
          ]}
        />
      ),
    },
    {
      image: rancher,
      title: "Scalability, Flexibility & Expert Management",
      content: (
        <ContentCard
          points={[
            "Elastic resource allocation to dynamically scale clusters based on workload demands.",
            "Support for multiple Kubernetes distributions including RKE, K3s, EKS, AKS, and GKE.",
            "Managed services & customization assistance for seamless updates and cluster optimization.",
          ]}
        />
      ),
    },
    {
      image: rancher,
      title: "Robust Security",
      content: (
        <ContentCard
          points={[
            "Zero-trust security model to enforce strict access controls and continuous verification.",
            "Automated backups & disaster recovery to ensure data protection and business continuity.",
          ]}
        />
      ),
    },
    {
      image: rancher,
      title: "Seamless Integration",
      content: (
        <ContentCard
          points={[
            "CI/CD pipeline integration for streamlined application deployment.",
            "Monitoring & logging tools for real-time insights into cluster performance and health.",
          ]}
        />
      ),
    },
  ],
};
